module.exports = __webpack_public_path__ + "03_mid_black.8af71f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_mid_black.png
// module id = KxQ7
// module chunks = 0